import script from "./info-card.vue?vue&type=script&setup=true&lang=js"
export * from "./info-card.vue?vue&type=script&setup=true&lang=js"

import "./info-card.vue?vue&type=style&index=0&id=72b2aba6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b2aba6"]])

export default __exports__